/**
 * Custom Order permission keys. Which role has which key is data, not code:
 * the `customOrderRoles` collection maps users.customOrderRole to a list of
 * these, and /api/user/profile returns it as `customOrderPermissions`.
 * Visibility only — nothing server-side enforces them.
 */

/** Manage Orders page (every customer's orders), the update panel, and the staff credit exemption. */
export const CO_MANAGE = "manage" as const;
/** Sales order number field on the order form. */
export const CO_SO_NUMBER = "soNumber" as const;
/** The "Delivered" team status. */
export const CO_MARK_DELIVERED = "markDelivered" as const;
/** The customer's delivery email addresses on staff views. */
export const CO_DELIVERY_EMAILS = "deliveryEmails" as const;
/** Who an order is assigned to: the column, and the picker on the Update card. */
export const CO_ASSIGN = "assign" as const;

export type CustomOrderPermission =
  | typeof CO_MANAGE
  | typeof CO_SO_NUMBER
  | typeof CO_MARK_DELIVERED
  | typeof CO_DELIVERY_EMAILS
  | typeof CO_ASSIGN;
